<template>
    <div class="">
        <md-dialog :md-active.sync="showDialog" >
          <validation-observer v-slot="{ handleSubmit }" tag="div">
            <form @submit.prevent="handleSubmit(addNewClient)" class="form">
              <md-dialog-title>
                  <span>New Client</span>
                  <button class="btn btn--close" @click="cancel"></button>
              </md-dialog-title>      
              <div class="form__content">                    
                <ValidationProvider :rules="{required :true, min:3}" v-slot="{ errors }" tag="div">
                  <md-field>                      
                    <label>Client name</label>
                    <md-input v-model="client.name" />
                  </md-field>
                  <div class="form__error">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider rules="required" v-slot="{ errors }" tag="div">
                  <md-field>                      
                    <label>Client logo</label>
                    <!-- <md-file   
                      v-model="fileNamesToUpload"
                      v-on:change="filesSelected"
                      accept="image/*"
                    /> -->
                    <div class="md-file">
                      <input readonly="readonly" class="md-input" v-model="fileNamesToUpload" />
                      <input type="file" accept="image/*" @change="filesSelected" />
                    </div>
                  </md-field>
                  <div class="form__error">{{ errors[0] }}</div>
                </ValidationProvider>
                <ValidationProvider :rules="{required :true, min:3}" v-slot="{ errors }" tag="div">
                  <md-field>                      
                    <label>Client information</label>
                    <md-textarea v-model="client.description"></md-textarea>
                  </md-field>
                  <div class="form__error">{{ errors[0] }}</div>
                </ValidationProvider>     
              </div>       
                <md-dialog-actions>
                  <div class="md-layout">
                    <div class="md-layout-item">
                      <md-button class="md-primary modal-cancel-btn" @click="cancel">Cancel</md-button>
                    </div>
                    <div class="md-layout-item text-right">
                    <md-button class="md-primary modal-save-btn" type="submit">Save Client</md-button>
                    </div>
                  </div>
                </md-dialog-actions>
            </form>
          </validation-observer>
        </md-dialog>
            
        <div class='buttonContainer'>
            <md-button class="btn newClientButton" @click="showDialog = true">add new client</md-button>            
        </div>
    </div>
</template>


<script>
import apiHandlerMI from "@/mixins/apiHandlerMI.js";
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {required, min} from 'vee-validate/dist/rules';
import {setInteractionMode} from 'vee-validate';

setInteractionMode('eager');
extend('required', {
  ...required,
  message: "This field is required."
});
extend('min', {
  ...min,
  message: "This field should contain at least 3 letters"
});

export default {
  mixins: [apiHandlerMI],
  data(){
    return{
      showDialog: false,
      active: false,
      client: {
        name: '',
        description: '',
        
      },
      error: {},

      needUpload : false,
      type: 'square',
      filesToUpload: null,
      fileNamesToUpload: null,
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
    methods:{
      filesSelected(event) {
        this.needUpload = true;
        this.client.logo = undefined;
        this.filesToUpload = event.target.files;
        this.fileNamesToUpload = this.filesToUpload[0].name
      },
      upload_selected: function(num = 0) {
        if (!this.needUpload)
          return false;
        const _this = this;
        if (!(this.filesToUpload || []).length) {
          
          this.error.logo = "Image required!";
          this.$forceUpdate();
          return;
        }
        if (!this.type) {
          this.error.logo  = "Type required!";
          this.$forceUpdate();
          return;
        }
         this.error.logo  = undefined;
        if (this.filesToUpload.length <= num) {
          this.fileNamesToUpload = undefined;
          //this.uploadSuccess = `You have successfully uploaded ${num} files`;
          setTimeout(() => {
            _this.uploadSuccess = undefined;
          }, 3000);
          return;
        }

        let file = this.filesToUpload[num];

        const formData = new FormData();
        formData.append("files[0]", file);
        formData.append('payment_cluster_id',this.$store.state.user.main_payment_cluster);
        formData.append("folder",'clients');
        formData.append("upload_type", this.type);

        var url = "image";
        if (this.filesToUpload[num].type == "application/pdf") url = "document";
        //console.log("start_upload");
        this.post(
          "filemanager/upload/" + url,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          },
          function(resp) {
            _this.client.logo = resp.data.images[0].id
            _this.needUpload = false;
            _this.addClientData();
            //_this.upload_selected(num + 1);
          }
        );
      },
      addNewClient(){
        
        this.upload_selected();
        
      },
      addClientData(){
        var _this = this;
        this.client.payment_cluster_id = this.$store.state.user.main_payment_cluster;
        console.log(this.client);
        this.post('/usermanager/create_client',this.client,{},function(){
          //console.log(resp.data);
          _this.client = {
            name: '',
            description: '',
            
          };
          if (_this.$parent.refreshClients)
            _this.$parent.refreshClients();
          _this.showDialog = false
        },function(resp){
          //console.log(resp);
          _this.error = resp.data.error;
          this.$forceUpdate();
        })
      },
      cancel(){
        this.showDialog = false
        
      }
    }
 }

</script>